<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div> <br>

<div style="border: 1px solid rgba(63, 74, 63, 0.2);background: #fff;padding: 5px;">
    <div>
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3">
                <div class="dropdown">
                </div>
            </div>
            <div class="d-flex gap-3">
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openAddPopup()" (keydown.enter)="openAddPopup()"
                    *ngIf="columnCount == 0 && !hideActionBtn && !auService.isPeerReviewer">
                    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px"
                        alt="Add Question" />
                    <span class="reload_text text-white">Add Question</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="callReorderFunc()" (keydown.enter)="callReorderFunc()"
                    *ngIf="columnCount == 0 && !hideActionBtn && !auService.isPeerReviewer">
                    <i class="fas fa-reorder" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Reorder Questions</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openPopup()" (keydown.enter)="openPopup()"
                    *ngIf="showBulkStatus && showAuditorColumn && !freezeAuditorColumn">
                    <i class="fa fa-bars" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Bulk Status</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">PDF Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
                    (keydown.enter)="openAuditTrail('overAll',0)">
                    <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Audit Trail</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="refreshQuestions()" (keydown.enter)="refreshQuestions()">
                    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reload</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="displayQuestionAndAnswerContainer" class="question-and-answer-container"
        style="margin:10px;border: 0.75px solid #cfcfcf;">
        <div class="row" style="margin: 10px;">
            <div class="d-flex row question-and-answer-header">
                <div style=" text-align: center;vertical-align: bottom;width:5%;">
                    <div style="display: flex;">
                        <div>
                            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div>
                            <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBox"
                                (change)="dataGridParentCheckBoxChecked($event)">
                        </div>
                    </div>
                </div>
                <span style="width:3%;">
                    Seq.
                </span>
                <span style="width:50%;">
                    Question
                </span>
                <span *ngIf="showAuditeeColumn" style="width:16%;"><span *ngIf="auService.isAuditee"
                        class="mandatory-symbol">*</span>
                    Response/Comments
                </span>
                <span *ngIf="showAuditorColumn" style="width:17%;"><span *ngIf="auService.isAuditor"
                        class="mandatory-symbol">*</span>
                    Review Status/Auditor Comments
                </span>
                <span style="width:3%;">
                </span>
            </div>
        </div>

        <div class="row" *ngFor="let question of auService.questionnaireList; let idx = index;"
            style="margin: 10px; margin-bottom: -15px;">
            <div class="d-flex row question-and-answer-body" [ngStyle]="{'background':idx % 2 === 0?'':'white'}">
                <div style=" text-align: center;width:5%;">
                    <div style="display: flex;">
                        <div [ngClass]="question.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div>
                            <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                                (change)="dataGridChildCheckBoxChecked($event, question, idx)">
                        </div>
                    </div>
                </div>

                <span style="width:3%;"> {{question.questionSeq}} </span>

                <span style="width:50%;" class="question" [attr.title]="question.question">
                    {{question.question}}
                </span>

                <span style="width:16%;"
                    *ngIf="showAuditeeColumn || (question.response != null && question.response != undefined)"
                    [ngStyle]="freezeAuditeeColumn ? {'cursor': 'not-allowed !important'} : {}" type="text">
                    <ng-container *ngIf="question.fieldTypeCode =='Text Field'">
                        <input class="col-md-6 input-filed-continers" [(ngModel)]="question.fieldValues"
                            [disabled]="freezeAuditeeColumn">
                    </ng-container>

                    <ng-container *ngIf="question.fieldTypeCode =='Date Field'">
                        <input type="text" class="form-control data-picker-continer" bsDatepicker
                            [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses"
                            [(ngModel)]="question.fieldValues" [disabled]="freezeAuditeeColumn">
                    </ng-container>

                    <ng-container *ngIf="question.fieldTypeCode =='Large Text Field'">
                        <textarea id="groupActiveInactiveReason" type="text" class="input-filed-textarea" rows="12"
                            [(ngModel)]="question.fieldValues" [disabled]="freezeAuditeeColumn"></textarea>
                    </ng-container>

                    <ng-container *ngIf="question.fieldTypeCode =='Drop Down'">
                        <mat-select matInput placeholder="Select" [(ngModel)]="question.selectedFlexifieldValue"
                            (closed)="organizedQuesAndAnswTxt=''" (click)="focusSearch('organizedQuesAndAnswSearch')"
                            (keydown.enter)="focusSearch('organizedQuesAndAnswSearch')"
                            [disabled]="freezeAuditeeColumn">
                            <input type="search" id="organizedQuesAndAnswSearch" class="dropdownsearchstyle"
                                [(ngModel)]="organizedQuesAndAnswTxt" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of question.organizedQuesAndAnswData| assessmentSearch :organizedQuesAndAnswTxt"
                                (onSelectionChange)="onQuesAndAnswSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </ng-container>

                    <ng-container *ngIf="question.fieldTypeCode =='Multiselect Drop Down'">
                        <mat-select matInput multiple placeholder="Select" #flexifieldValueSelected1
                            [(ngModel)]="question.selectedFlexifieldValue" (closed)="flexifieldValueTxt=''"
                            (click)="focusSearch('flexifieldValueSearch')"
                            (keydown.enter)="focusSearch('flexifieldValueSearch')">
                            <input type="search" id="flexifieldValueSearch" class="dropdownsearchstyle"
                                [(ngModel)]="flexifieldValueTxt" matInput placeholder="search">
                            <div class="select-all">
                                <mat-checkbox [(ngModel)]="question.isSelectAllChecked"
                                    (ngModelChange)="toggleAllSelection('flexifieldValueSelected', question)">Select
                                    All</mat-checkbox>
                            </div>
                            <mat-option
                                *ngFor="let item1 of question.organizedQuesAndAnswData| multiAssessmentSearchPipe :flexifieldValueTxt"
                                [value]="item1.valueExp"
                                (onSelectionChange)="onQuesAndAnswSelect($event, item1, question)">
                                {{ item1.displayExp }}
                            </mat-option>
                        </mat-select>
                    </ng-container>

                    <div *ngIf="question.fieldTypeCode =='Check Box'">
                        <span *ngFor="let checkBoxField of question.fieldValuesList" style="margin-left: 10px;">
                            <input type="checkbox" value="{{checkBoxField.name}}" style="width: 20px;height: 20px;"
                                [(ngModel)]="checkBoxField.checked" [disabled]="freezeAuditeeColumn">
                            <span style="color: black;font-size: 14px;">{{checkBoxField.name}}</span>
                        </span>
                    </div>

                    <ng-container *ngIf="question.fieldTypeCode =='Radio Button'">
                        <mat-radio-group [(ngModel)]="question.response">
                            <mat-radio-button *ngFor="let val of question.organizedQuesAndAnswData"
                                [value]="val.valueExp"
                                [disabled]="freezeAuditeeColumn">{{val.displayExp}}</mat-radio-button>
                        </mat-radio-group>
                    </ng-container>

                    <textarea class="col-md-12 mt-2 input-filed-textarea"
                        [ngStyle]="freezeAuditeeColumn ? {'cursor': 'not-allowed !important','margin-top':'5px;'} : {'margin-top':'5px;'}"
                        type="text" rows="6" [(ngModel)]="question.auditeeComments" [disabled]="freezeAuditeeColumn">
                    </textarea>

                    <ng-container *ngIf="question.docs">
                        <span *ngFor="let document of question.docs; let idx1 = index;">
                            <span *ngIf="document.createdBy!=this.qualityService.activity.leadAuditor"
                                class="d-flex col-sm-12" style="cursor: pointer;"><a
                                    style="color:blue !important">{{document.documentName}}.{{document.documentExtn}}</a></span>
                        </span>
                    </ng-container>

                    <ng-container *ngIf="auService.isAuditee">
                        <i [ngClass]="question.isDocumentUploaded?'fa-solid fa-upload':'fa-solid fa-upload'"
                            (click)="uploadBtn(question,idx)" (keydown.enter)="uploadBtn(question,idx)"
                            matTooltip="Upload Documents"></i>
                    </ng-container>
                </span>

                <span style="width:17%;"
                    *ngIf="showAuditorColumn || (question.status != null && question.status != undefined && question.status != 'Pending')">
                    <mat-select matInput placeholder="Select" [(ngModel)]="question.selectedReviewStatus"
                        (closed)="reviewStatusTxt=''" (click)="focusSearch('reviewStatusSearch')"
                        (keydown.enter)="focusSearch('reviewStatusSearch')" [disabled]="freezeAuditorColumn"
                        [ngStyle]="freezeAuditorColumn ? {'cursor': 'not-allowed !important'} : {}">
                        <input type="search" id="reviewStatusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="reviewStatusTxt" matInput placeholder="search">
                        <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                        <mat-option
                            *ngFor="let item of question.reviewStatusDropDown| assessmentSearch :reviewStatusTxt"
                            [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>

                    <textarea class="col-md-12 mt-2 input-filed-textarea"
                        [ngStyle]="freezeAuditorColumn ? {'cursor': 'not-allowed !important','margin-top':'5px;'} : {'margin-top':'5px;'}"
                        type="text" rows="6" [(ngModel)]="question.auditorComments" [disabled]="freezeAuditorColumn">
                    </textarea>

                    <span *ngIf="question.docs">
                        <span *ngFor="let document of question.docs; let idx = index;">
                            <span *ngIf="document.createdBy==this.qualityService.activity.leadAuditor"
                                class="d-flex col-sm-12" style="cursor: pointer;"><a
                                    style="color:blue !important">{{document.documentName}}.{{document.documentExtn}}</a></span>
                        </span>
                    </span>

                    <ng-container *ngIf="(auService.isAuditor)">
                        <i [ngClass]="question.isDocumentUploaded ?'fa-solid fa-upload': 'fa-solid fa-upload'"
                            matTooltip="Upload Documents" (click)="uploadBtn(question,idx)"
                            (keydown.enter)="uploadBtn(question,idx)"></i>
                    </ng-container>

                </span>

                <span class="actions" *ngIf="this.auService.tabName=='Audit Plan'" style="width:1%;">
                    <span *ngIf="columnCount == 0 && qualityService.activity.status != 'Initiated' && !hideActionBtn"
                        matTooltip="Delete Question">
                        <img src="../../../assets/img/cr_module/delete.svg" width="16" height="16" alt="delete"
                            (keydown.enter)="deleteQuestion(question)" (click)="deleteQuestion(question)" />
                    </span>
                </span>
                <span class="actions" *ngIf="this.auService.tabName=='Audit Plan'" style="width:1%;">
                    <span *ngIf="columnCount == 0 && qualityService.activity.status != 'Initiated' && !hideActionBtn"
                        matTooltip="Edit Question">
                        <img src="../../../assets/img/cr_module/Edit.svg" width="16" height="16" alt="edit"
                            (keydown.enter)="editQuestion(question)" (click)="editQuestion(question)" />
                    </span>
                </span>
                <span class="actions" style="width:3%;">
                    <span matTooltip="Audit Trail">
                        <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20"
                            height="20" src="../../assets/img/trail-individual.svg"
                            (click)="openAuditTrail('individual',question)"
                            (keydown.enter)="openAuditTrail('individual',question)" />
                    </span>
                </span>


            </div>
        </div>
        <br>
        <div class="row" *ngIf="(this.auService.isAuditee && (qualityService.activity.status=='Initiated'  || 
            qualityService.activity.status=='Initiated/Auditor Requested More Info. On Q&A Responses' ||
            qualityService.activity.status=='Auditor Requested More Info. On Q&A Responses' || 
            qualityService.activity.status=='In Progress/Q&A Pending' || 
            qualityService.activity.status=='In Progress/Auditor Requested More Info. On Q&A Responses')) || 
            (this.auService.isAuditor && (qualityService.activity.status=='Received Q&A Response' || 
            qualityService.activity.status=='Initiated/Received Q&A Response' || 
            this.qualityService.activity.status == 'In Progress/Received Q&A Response'))">

            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="saveButton()">
                    <i class="fas fa-check"></i> Save
                </button>
            </div>
        </div>
        <br>
    </div>
</div>

<ng-template #vendorPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelVendorPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Bulk Operation </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
        <div class="d-flex row">
            <label class="col-sm-1" for="email">Status</label>
            <span class="col-sm-1 mandatory-symbol">*</span>
            <span>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedCommonReviewStatus"
                    (closed)="commonReviewStatusTxt=''" (click)="focusSearch('commonReviewStatusSearch')"
                    (keydown.enter)="focusSearch('commonReviewStatusSearch')">
                    <input type="search" id="commonReviewStatusSearch" class="dropdownsearchstyle"
                        [(ngModel)]="commonReviewStatusTxt" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option
                        *ngFor="let item of reviewStatusDropDownBulkStatus| assessmentSearch :commonReviewStatusTxt"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </span>
        </div>
        <div class="row">
            <label class="col-sm-2" for="email">Comments</label><span class="col-sm-1 mandatory-symbol">*</span>
            <span>
                <textarea class="col-md-12 input-filed-textarea" type="text" rows="6"
                    [(ngModel)]="auditorComments"></textarea>
            </span>
        </div>
        <div class="row" style="margin-top: 5%;">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="saveButton1()">
                    <i class="fas fa-check"></i> OK
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #reorderContentPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div style="margin: 15px 15px;">
        <b>Drag and drop to reorder the Question sequence</b>
        <div class="table-container" style="max-height: 500px;overflow-y:auto">
            <table class="dynamic-table-container">
                <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Question Seq</span> <span class="grid-header-container"></span> </th>
                <th style=" text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Name</span> <span class="grid-header-container"></span> </th>
                <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>New Seq</span> <span class="grid-header-container"></span> </th>

                <tbody cdkDropList (cdkDropListDropped)="drop($event)">
                    <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let content of contentList let idx = index;">
                        <td style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{content.questionSeq}}</span></td>
                        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{content.question}}</span></td>
                        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{content.newSeq}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="reorderContentFunction()">
                <i class="fa fa-redorder"></i> Reorder
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #addPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelAddFunction()" mat-button>
            <i class="fa popupClose">&#xf00d;</i>
        </button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="form-continer">
            <mat-radio-group *ngIf="operationFlag == 'ADD'" [(ngModel)]="auQuestionsData.addQuestionType"
                (change)="onOptionChanged($event)">
                <mat-radio-button value="manually">Add Question Manually</mat-radio-button>
                <mat-radio-button value="fromTemplate">Add Question From Template</mat-radio-button>
            </mat-radio-group>
            <div>
                <div class="row" *ngIf="auQuestionsData.addQuestionType == 'manually'">
                    <div class="col-md-12">
                        <div>
                            <label id="question-validation" for="email">Question</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                            [(ngModel)]="auQuestionsData.question"
                            (ngModelChange)="onNgModuleChange(auQuestionsData.questionSeq, 'question-validation')"></textarea>
                    </div>
                    <div class="col-md-4">
                        <div>
                            <label id="field-type-validation" for="email">Field Type</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedFieldType"
                            (closed)="fieldTypeTxt=''" (click)="focusSearch('fieldTypeSearch')"
                            (keydown.enter)="focusSearch('fieldTypeSearch')">
                            <input type="search" id="fieldTypeSearch" class="dropdownsearchstyle"
                                [(ngModel)]="fieldTypeTxt" matInput placeholder="search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option *ngFor="let item of fieldTypeDropDown| assessmentSearch :fieldTypeTxt"
                                (onSelectionChange)="onFieldTypeSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-8" *ngIf="markFieldValuesAsMandatory">
                        <div>
                            <label id="field-value-validation" for="email">Field Values</label>
                            <span class="sub-label">(comma separated)</span>
                            <span *ngIf="markFieldValuesAsMandatory" class="mandatory-symbol">*</span>
                        </div>
                        <textarea id="fieldValues" type="text" class="input-filed-textarea" rows="4" cols="50"
                            [(ngModel)]="auQuestionsData.fieldValues"></textarea>
                    </div>
                </div>
                <div class="row" *ngIf="auQuestionsData.addQuestionType == 'fromTemplate'">
                    <div class="table-container">
                        <table class="dynamic-table-container">
                            <th style="min-width: 60px; text-align: center;"
                                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                <div style="display: flex;">
                                    <div>
                                        <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                </div>
                            </th>
                            <th class="grid-header-container" (focus)="focusEmpty()"
                                *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
                                [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                                class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                    <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
                                    <div class="d-flex gap-2 align-items-center">
                                        <div>
                                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                                alt="sort" />
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th class="sticky-col first-col"></th>
                            <tr>
                                <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col' : ''"></td>
                                <td *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                                    [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width: '200px'}"
                                    class="sticky-dynamic-row1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                                    <div class="row-search-container">
                                        <input type="text" class="form-control" placeholder="Search"
                                            (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
                                    </div>
                                </td>
                            </tr>
                            <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
                                [class.highlightRow]="list.childCheckBoxs">
                                <td style="min-width: 60px; text-align: center;"
                                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                    <div style="display: flex;">
                                        <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                        </div>
                                        <div>
                                            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                                                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                                        </div>
                                    </div>
                                </td>
                                <td *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                                    class="sticky-dynamic-row1" (focus)="focusEmpty()"
                                    [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                                    (click)="detailsData(list,i)" (keydown.enter)="detailsData(list,i)"
                                    (mouseover)="cssfunction(i)" style="cursor:pointer">
                                    <span *ngIf="key.dataType=='CHECKBOX'">
                                        <div class="gridCheckBoxes" i>
                                            <img *ngIf="list[key.columnsListarray]"
                                                src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                                alt="Yes">
                                            <img *ngIf="list[key.columnsListarray]==false"
                                                src="../../assets/img/noAcessSymbol.svg" width="20" height="20"
                                                alt="No">
                                        </div>
                                    </span>
                                    <span
                                        [ngStyle]="{'color':i==0?'blue':'black','text-decoration':i==0?'underline':''}"
                                        *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">
                                        {{ list[key.columnsListarray] }}</span>
                                    <span *ngIf="key.dataType=='DATE'">
                                        {{ list[key.columnsListarray]}}
                                    </span>
                                </td>
                            </tr>
                        </table>
                        <div class="d-flex justify-content-center">
                            <div class="width-cheat small paginationCell">
                                <div class="d-flex align-items-center gap-3">
                                    <div class="pagination_text mt-3">
                                        {{ showingRowsText }}
                                        1-{{ perPage }} of {{ collectionSize | number }}
                                    </div>
                                    <div>
                                        <ngb-pagination class="leftpadding"
                                            (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                                            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                            [boundaryLinks]="true" size="sm">
                                        </ngb-pagination>
                                    </div>
                                    <div ngbDropdown class="mt-3">
                                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                            id="dropdownBasic1" ngbDropdownToggle>
                                            {{ perPage }}
                                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                                        </div>
                                        per page
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button *ngIf="auQuestionsData.addQuestionType == 'manually'" mat-stroked-button class="addButton"
                (click)="addFunction(auQuestionsData)">
                <ng-container *ngIf="operationFlag == 'ADD'; else edit">
                    <i class="fas fa-plus"></i> Add
                </ng-container>
                <ng-template #edit>
                    <i class="fas fa-edit"></i> Update
                </ng-template>
            </button>

            <button mat-stroked-button class="cancelButton" (click)="cancelAddFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Delete </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
                            class="mandatory-symbol">*</span></div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="deleteReason"></textarea>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="deleteButton" (click)="deleteFunction(deleteReason)">
                <i class="fa fa-trash"></i> Delete
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #selectQuestionPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelAddFunction()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle">Pick Question(s)</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>

        <div>
            <app-pick-questions (response)="on_response_emit($event)"></app-pick-questions>
        </div>
    </div>
</ng-template>

<ng-template #uploadDocuments>
    <button class="close close-button" (click)="cancelUploadBtnFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">Upload Documents</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div>
        <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
    </div>
</ng-template>

<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
        <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="align-center">
        <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
            }}
            ?</label>
    </div>
    <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
        <label for="email" style="font-size: .7rem; font-weight: bold;">
            <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
            <span *ngIf="manuallyPicked && maxCountReached">
                We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
            </span>
        </label>
    </div>
    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
        <div class="col-md-12" *ngIf="selectedColumns.length">
            <div><label for="email">Selected Column(s)</label></div>
            <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                [(ngModel)]="selectedColumnsAsString"></textarea>
        </div>
        <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
            <div class="col-md-6">
                <label for="radio">PDF Page Size</label>
                <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
                    <mat-radio-button *ngFor="let data of pdfPageSizes"
                        [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6" style="margin-top: 1.5%;">
                <label for="toggle">Pick Columns Manually?</label>&nbsp;
                <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
                    id="toggle">
                    <ng-container *ngIf="manuallyPicked; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-sm-4">
                    <label for="email">Is Save Report?</label>
                </div>
                <div class="col-sm-8">
                    <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
                        <ng-container *ngIf="isSaveReport; else noisSaveReport">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #noisSaveReport>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="row justify-content-md-center" *ngIf="isSaveReport">
                <div class="col-sm-4">
                    <label for="email">Report Name</label>
                </div>
                <div class="col-sm-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
                </div>
            </div>
        </div>
        <div class="row mt-3" *ngIf="manuallyPicked">
            <div class="col-md-12">
                <div><label id="pdf-select-all" for="email">Select Column(s)</label><span
                        class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #pdf [(ngModel)]="selectedColumns"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
                    (keydown.enter)="focusSearch('focus-department-search')">
                    <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="departmentSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="pdfColumnSelection" (change)="toggleAllSelection('pdf')">Select
                            All</mat-checkbox>
                    </div>
                    <mat-option
                        *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : departmentSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                        {{item.displayExp}}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
        <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
            <i class="fa fa-file-excel-o"></i> Generate
        </button>
        <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
            <i class="fa fa-file-pdf-o"></i> Generate
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #resultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelResultPopup()" mat-button>
            <i class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Questionnaire Result(s) </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Question</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                    <th class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of resultGrid; let idx = index;">
                        <td class="row-data" style="max-width: 400px;">
                            {{ r.question.question }}
                        </td>
                        <td class="row-data"
                            [ngStyle]="r.result.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.result.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>